'use strict';

const VARIANTS = {
    OUTLINED: 'outlined',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TEXT: 'text',
};

exports.VARIANTS = VARIANTS;
//# sourceMappingURL=variants.js.map
